// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import {
    addToChainAfter,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, DispatchResetQuotes, PopulateApiParameter } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import { CustomAppState } from "@tps/App/Store/Reducers";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

export const TpsPopulateApiParameter: any = (props: any) => {
    const state = props.getState();
    const {
        pages: {
            checkoutReviewAndSubmit: { cartId, requestedDeliveryDate, requestedPickupDate },
        },
    } = state;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined" ? requestedDeliveryDate : cart.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined" ? requestedPickupDate : cart.requestedPickupDateDisplay;

    props.apiParameter = {
        cart: {
            ...cart,
            // XNG-Change
            poNumber: (state as CustomAppState)?.xCheckout?.poNumber?.trim() || "",
            status: "AwaitingApproval",
            requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
            requestedPickupDate: convertDateToApiFormat(tempPickupDate),
        },
    };
};

// XNG-Change
export const DispatchResetStates: any = (props: any) => {
    props.dispatch({
        type: "xShippingDetails/ResetAllShippingDetails",
    } as any);
    props.dispatch({
        type: "xCheckout/Reset",
    } as any);
};

replaceInChain(chain, PopulateApiParameter, TpsPopulateApiParameter);
addToChainAfter(chain, DispatchResetQuotes, DispatchResetStates);


